import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import validator from 'validator';
import range from 'lodash/range';
import { v4 } from 'uuid';
import includes from 'lodash/includes';
import lowerCase from 'lodash/lowerCase';
import find from 'lodash/find';
import {
  Card,
  CardTitle,
  CardHeader,
  CardText,
  CardActions,
} from 'material-ui/Card';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import AutoComplete from 'material-ui/AutoComplete';
import Chip from 'material-ui/Chip';
import CloseIcon from 'material-ui/svg-icons/action/delete';
import IconButton from 'material-ui/IconButton';
import CircularProgress from 'material-ui/CircularProgress';
import Dialog from 'material-ui/Dialog';
import { theme } from '../../utils/getTheme';
import availStreams from '../../utils/streams';
import { database } from '../../utils/configureFirebase';

const ContentWrapper = styled.div`
  width: 80%;
  margin: 0 auto;

  & > * + * {
    margin-top: 24px;
  }
`;

const TextFieldContainer = styled.div`
  display: flex;
  flex: wrap;
  justify-content: space-between;
  width: 100%;
`;

const CheckboxWrapper = styled.div`
  display: flex;
`;

const CheckboxContainer = styled.div`
  width: 50%;
`;

const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const CardIcon = styled.div`
  position: absolute;
  top: 12px;
  right: 16px;
  opacity: 0.54;
`;

const ContentContainer = styled.div`
  & > * {
    margin-bottom: 16px;
  }
`;

const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

class EarlyBirdCollegeEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: '',
      collegeName: '',
      collegeNameErrorMessage: undefined,
      society: '',
      societyErrorMessage: undefined,
      address: '',
      addressErrorMessage: undefined,
      state: '',
      stateErrorMessage: undefined,
      city: '',
      cityErrorMessage: undefined,
      pincode: '',
      pincodeErrorMessage: undefined,
      university: '',
      universityErrorMessage: undefined,
      instituteType: '',
      instituteTypeErrorMessage: undefined,
      collegeYear: '',
      collegeYearErrorMessage: undefined,
      website: '',
      websiteErrorMessage: undefined,
      degreeText: '',
      degrees: [],
      degreesErrorMessage: undefined,
      streams: [],
      streamSearchText: '',
      streamsErrorMessage: undefined,
      currentStrength: '',
      currentStrengthErrorMessage: undefined,
      promoterShow: false,
      promoterContact: [],
      promoterContactErrorMessage: undefined,
      promoterName: '',
      promoterNameErrorMessage: undefined,
      promoterEmail: '',
      promoterEmailErrorMessage: undefined,
      promoterPrimaryNum: '',
      promoterPrimaryNumErrorMessage: undefined,
      promoterSecondaryNum: '',
      principleContact: {},
      principleName: '',
      principleNameErrorMessage: undefined,
      principleEmail: '',
      principleEmailErrorMessage: undefined,
      principlePrimaryNum: '',
      principlePrimaryNumErrorMessage: undefined,
      principleSecondaryNum: '',
      headTPO: {},
      headTpoName: '',
      headTpoNameErrorMessage: undefined,
      headTpoEmail: '',
      headTpoEmailErrorMessage: undefined,
      headTpoPrimaryNum: '',
      headTpoPrimaryNumErrorMessage: undefined,
      headTpoSecondaryNum: '',
      accredShow: false,
      accreditations: [],
      accreditationsErrorMessage: undefined,
      accredName: '',
      accredNameErrorMessage: undefined,
      accredYear: undefined,
      accredYearErrorMessage: undefined,
      accredDesc: '',
      accredDescErrorMessage: undefined,
      confirmModalOpen: false,
      hasAcceptedTerms: false,
      isLoading: true,
      completionModal: false,
    };
  }
  componentDidMount() {
    const { match } = this.props;
    this.registrationRef = database.ref(`contact/college/${match.params.id}`);
    this.registrationRef.on('value', this.setRegistrationData);
  }

  componentWillUnmount() {
    this.registrationRef.off('value', this.setRegistrationData);
  }

  setRegistrationData = (snapshot) => {
    if (snapshot) {
      const college = snapshot.val();
      this.setState(() => ({
        ...college,
        principleName: college.principleContact.principleName,
        principleEmail: college.principleContact.principleEmail,
        principlePrimaryNum: college.principleContact.principlePrimaryNum,
        principleSecondaryNum: college.principleContact.principleSecondaryNum,
        headTpoName: college.headTPO.headTpoName,
        headTpoEmail: college.headTPO.headTpoEmail,
        headTpoPrimaryNum: college.headTPO.headTpoPrimaryNum,
        headTpoSecondaryNum: college.headTPO.headTpoSecondaryNum,
        isLoading: false,
      }));
    }
  };

  setFields = (fieldName, value) => {
    this.setState(() => ({
      [fieldName]: value,
    }));
  };

  getAvailStreams = () => {
    const { streams } = this.state;
    return availStreams.filter(stream => !find(streams, { stream }));
  };

  addStream = (stream) => {
    this.setState(state => ({
      streams: [
        ...state.streams,
        {
          id: v4(),
          stream,
        },
      ],
      streamSearchText: '',
      streamsErrorMessage: undefined,
    }));
  };

  removeStream = (id) => {
    this.setState(state => ({
      streams: state.streams.filter(stream => stream.id !== id),
    }));
  };

  isDegreePresent = (degree) => {
    const { degrees } = this.state;
    return degrees.indexOf(degree) !== -1;
  };

  addDegree = (degree) => {
    this.setState(state => ({
      degrees: [...state.degrees, degree],
      degreesErrorMessage: undefined,
    }));
  };

  removeDegree = (degree) => {
    this.setState(state => ({
      degrees: state.degrees.filter(val => val !== degree),
    }));
  };

  showPromoterFields = () => {
    this.setState(() => ({
      promoterShow: true,
    }));
  };

  cancelPromoter = () => {
    this.setState(() => ({
      promoterShow: false,
    }));
  };

  addPromoterContact = () => {
    const {
      promoterName,
      promoterEmail,
      promoterPrimaryNum,
      promoterSecondaryNum,
      promoterContact,
    } = this.state;
    let flag = false;

    if (validator.isEmpty(promoterName)) {
      this.setState(() => ({
        promoterNameErrorMessage: 'Name is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        promoterNameErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(promoterEmail)) {
      this.setState(() => ({
        promoterEmailErrorMessage: 'Email is required',
      }));
      flag = true;
    } else if (!validator.isEmail(promoterEmail)) {
      this.setState(() => ({
        promoterEmailErrorMessage: 'Incorrect format of Email',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        promoterEmailErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(promoterPrimaryNum)) {
      this.setState(() => ({
        promoterPrimaryNumErrorMessage: 'Primary Contact is required',
      }));
      flag = true;
    } else if (!validator.isMobilePhone(promoterPrimaryNum, 'en-IN')) {
      this.setState(() => ({
        promoterPrimaryNumErrorMessage: 'Incorrect format of Contact',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        promoterPrimaryNumErrorMessage: undefined,
      }));
    }

    if (!flag) {
      this.setState(() => ({
        promoterContact: [
          ...promoterContact,
          {
            id: v4(),
            name: promoterName,
            email: promoterEmail,
            primaryNum: promoterPrimaryNum,
            secondaryNum: promoterSecondaryNum,
          },
        ],
        promoterName: '',
        promoterEmail: '',
        promoterPrimaryNum: '',
        promoterSecondaryNum: '',
        promoterShow: false,
        promoterContactErrorMessage: undefined,
      }));
    }
  };

  removePromoterContact = (id) => {
    this.setState(state => ({
      promoterContact: state.promoterContact.filter(
        promoter => promoter.id !== id,
      ),
    }));
  };

  showAccredFields = () => {
    this.setState(() => ({
      accredShow: true,
    }));
  };

  cancelAccred = () => {
    this.setState(() => ({
      accredShow: false,
    }));
  };

  addAccred = () => {
    const { accredName, accredYear, accredDesc, accreditations } = this.state;
    let flag = false;

    if (validator.isEmpty(accredName)) {
      this.setState(() => ({
        accredNameErrorMessage: 'Accreditations Name is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        accredNameErrorMessage: undefined,
      }));
    }

    if (typeof accredYear === 'undefined') {
      this.setState(() => ({
        accredYearErrorMessage: 'Accreditations Year is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        accredYearErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(accredDesc)) {
      this.setState(() => ({
        accredDescErrorMessage: 'Accreditations Description is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        accredDescErrorMessage: undefined,
      }));
    }

    if (!flag) {
      this.setState(() => ({
        accreditations: [
          ...accreditations,
          {
            id: v4(),
            name: accredName,
            year: accredYear,
            description: accredDesc,
          },
        ],
        accredName: '',
        accredYear: '',
        accredDesc: '',
        accredShow: false,
        accreditationsErrorMessage: undefined,
      }));
    }
  };

  removeAccred = (id) => {
    this.setState(state => ({
      accreditations: state.accreditations.filter(accred => accred.id !== id),
    }));
  };

  validateInfo = () => {
    const {
      collegeName,
      society,
      university,
      instituteType,
      website,
      address,
      city,
      state,
      pincode,
      collegeYear,
      degrees,
      streams,
      currentStrength,
      promoterContact,
      principleName,
      principleEmail,
      principlePrimaryNum,
      headTpoName,
      headTpoEmail,
      headTpoPrimaryNum,
      accreditations,
    } = this.state;
    let flag = false;
    const regularEpxression = /^[0-9]+$/;

    if (validator.isEmpty(collegeName)) {
      this.setState(() => ({
        collegeNameErrorMessage: 'Institute name is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        collegeNameErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(society)) {
      this.setState(() => ({
        societyErrorMessage: 'Name of Trust/Society is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        societyErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(university)) {
      this.setState(() => ({
        universityErrorMessage: 'Affiliated University is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        universityErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(instituteType)) {
      this.setState(() => ({
        instituteTypeErrorMessage: 'Institute Type is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        instituteTypeErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(website)) {
      this.setState(() => ({
        websiteErrorMessage: 'Website is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        websiteErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(address)) {
      this.setState(() => ({
        addressErrorMessage: 'Address is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        addressErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(state)) {
      this.setState(() => ({
        stateErrorMessage: 'State is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        stateErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(city)) {
      this.setState(() => ({
        cityErrorMessage: 'City is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        cityErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(pincode)) {
      this.setState(() => ({
        pincodeErrorMessage: 'Pincode is required',
      }));
      flag = true;
    } else if (!validator.isNumeric(pincode)) {
      this.setState(() => ({
        pincodeErrorMessage: 'Pincode should be numeric',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        pincodeErrorMessage: undefined,
      }));
    }

    if (!regularEpxression.test(collegeYear)) {
      this.setState(() => ({
        collegeYearErrorMessage: 'Year of Inception is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        collegeYearErrorMessage: undefined,
      }));
    }

    if (degrees.length <= 0) {
      this.setState(() => ({
        degreesErrorMessage: 'Atleast one degree is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        degreesErrorMessage: undefined,
      }));
    }

    if (streams.length <= 0) {
      this.setState(() => ({
        streamsErrorMessage: 'Atleast one stream is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        streamsErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(currentStrength)) {
      this.setState(() => ({
        currentStrengthErrorMessage: 'Current Strength is required',
      }));
      flag = true;
    } else if (!validator.isNumeric(currentStrength)) {
      this.setState(() => ({
        currentStrengthErrorMessage: 'Current Strength should be numeric',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        currentStrengthErrorMessage: undefined,
      }));
    }

    if (promoterContact.length === 0) {
      this.setState(() => ({
        promoterContactErrorMessage: 'Atleast one Chairman contact is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        promoterContactErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(principleName)) {
      this.setState(() => ({
        principleNameErrorMessage: 'Principle/Director name is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        principleNameErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(principleEmail)) {
      this.setState(() => ({
        principleEmailErrorMessage: 'Principle/Director email is required',
      }));
      flag = true;
    } else if (!validator.isEmail(principleEmail)) {
      this.setState(() => ({
        principleEmailErrorMessage: 'Incorrect format of Email',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        principleEmailErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(principlePrimaryNum)) {
      this.setState(() => ({
        principlePrimaryNumErrorMessage:
          'Principle/Director primary contact is required',
      }));
      flag = true;
    } else if (!validator.isMobilePhone(principlePrimaryNum, 'en-IN')) {
      this.setState(() => ({
        principlePrimaryNumErrorMessage: 'Incorrect format of Contact number',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        principlePrimaryNumErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(headTpoName)) {
      this.setState(() => ({
        headTpoNameErrorMessage: "Head of Placement's name is required",
      }));
      flag = true;
    } else {
      this.setState(() => ({
        headTpoNameErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(headTpoEmail)) {
      this.setState(() => ({
        headTpoEmailErrorMessage: "Head of Placement' email is required",
      }));
      flag = true;
    } else if (!validator.isEmail(headTpoEmail)) {
      this.setState(() => ({
        headTpoEmailErrorMessage: 'Incorrect format of Email',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        headTpoEmailErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(headTpoPrimaryNum)) {
      this.setState(() => ({
        headTpoPrimaryNumErrorMessage:
          "Head of Placement's primary contact is required",
      }));
      flag = true;
    } else if (!validator.isMobilePhone(headTpoPrimaryNum, 'en-IN')) {
      this.setState(() => ({
        headTpoPrimaryNumErrorMessage: 'Incorrect format of the contact number',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        headTpoPrimaryNumErrorMessage: undefined,
      }));
    }

    if (accreditations.length === 0) {
      this.setState(() => ({
        accreditationsErrorMessage: 'Atleast one accreditaion is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        accreditationsErrorMessage: undefined,
      }));
    }
    if (flag) {
      this.moveToTop();
    }

    return flag;
  };

  updateCollege = () => {
    this.setState(() => ({
      isLoading: true,
    }));
    const {
      id,
      collegeName,
      society,
      university,
      instituteType,
      website,
      address,
      state,
      city,
      pincode,
      collegeYear,
      degrees,
      streams,
      currentStrength,
      promoterContact,
      principleName,
      principleEmail,
      principlePrimaryNum,
      principleSecondaryNum,
      headTpoName,
      headTpoEmail,
      headTpoPrimaryNum,
      headTpoSecondaryNum,
      accreditations,
      timestamp,
    } = this.state;
    const { match, history } = this.props;

    const principleContact = {
      principleName,
      principleEmail,
      principlePrimaryNum,
      principleSecondaryNum,
    };

    const headTPO = {
      headTpoName,
      headTpoEmail,
      headTpoPrimaryNum,
      headTpoSecondaryNum,
    };

    const college = {
      id,
      collegeName,
      society,
      university,
      instituteType,
      website,
      address,
      state,
      city,
      pincode,
      collegeYear,
      degrees,
      streams,
      currentStrength,
      promoterContact,
      principleContact,
      headTPO,
      accreditations,
      registerationsOpen: true,
      timestamp,
    };

    const databaseRef = database
      .ref()
      .child(`contact/college/${match.params.id}`);
    // console.log(college, databaseRef);
    databaseRef
      .update({
        ...college,
        timestamp,
      })
      .then(() => {
        this.setState(() => ({
          isLoading: false,
          confirmModalOpen: false,
        }));
        history.push('/campuscape/campus');
      });
  };

  openConfirmModal = () => {
    this.setState(() => ({
      confirmModalOpen: true,
    }));
  };

  closeConfirmModal = () => {
    this.setState(() => ({
      confirmModalOpen: false,
    }));
  };

  moveToTop = () => {
    document
      .getElementById('headerDiv')
      .scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'end' });
  };

  render() {
    const {
      collegeName,
      collegeNameErrorMessage,
      society,
      societyErrorMessage,
      address,
      addressErrorMessage,
      state,
      stateErrorMessage,
      city,
      cityErrorMessage,
      pincode,
      pincodeErrorMessage,
      university,
      universityErrorMessage,
      instituteType,
      instituteTypeErrorMessage,
      collegeYear,
      collegeYearErrorMessage,
      website,
      websiteErrorMessage,
      degreeText,
      degrees,
      degreesErrorMessage,
      streams,
      streamSearchText,
      streamsErrorMessage,
      currentStrength,
      currentStrengthErrorMessage,
      promoterShow,
      promoterContact,
      promoterContactErrorMessage,
      promoterName,
      promoterNameErrorMessage,
      promoterEmail,
      promoterEmailErrorMessage,
      promoterPrimaryNum,
      promoterPrimaryNumErrorMessage,
      promoterSecondaryNum,
      principleName,
      principleNameErrorMessage,
      principleEmail,
      principleEmailErrorMessage,
      principlePrimaryNum,
      principlePrimaryNumErrorMessage,
      principleSecondaryNum,
      headTpoName,
      headTpoNameErrorMessage,
      headTpoEmail,
      headTpoEmailErrorMessage,
      headTpoPrimaryNum,
      headTpoPrimaryNumErrorMessage,
      headTpoSecondaryNum,
      accredShow,
      accreditations,
      accreditationsErrorMessage,
      accredName,
      accredNameErrorMessage,
      accredYear,
      accredYearErrorMessage,
      accredDesc,
      accredDescErrorMessage,
      confirmModalOpen,
      isLoading,
      // completionModal,
    } = this.state;
    const { history } = this.props;
    const today = new Date();
    const currentYear = today.getFullYear();
    return (
      <div id>
        {isLoading ? (
          <ContentContainer>
            <DialogContent>
              <CircularProgress />
            </DialogContent>
          </ContentContainer>
        ) : (
          <div>
            <ContentWrapper>
              <Card>
                <CardTitle title="Institute Information" />
                <CardText style={{ paddingTop: 0 }}>
                  <TextField
                    floatingLabelText="Institute Name *"
                    fullWidth
                    value={collegeName}
                    onChange={(_, value) => {
                      this.setFields('collegeName', value);
                    }}
                    errorText={collegeNameErrorMessage}
                  />

                  <TextField
                    floatingLabelText="Trust/Society *"
                    fullWidth
                    value={society}
                    onChange={(_, value) => {
                      this.setFields('society', value);
                    }}
                    errorText={societyErrorMessage}
                  />

                  <TextField
                    floatingLabelText="Address *"
                    fullWidth
                    value={address}
                    onChange={(_, value) => {
                      this.setFields('address', value);
                    }}
                    errorText={addressErrorMessage}
                  />

                  <TextFieldContainer>
                    <TextField
                      floatingLabelText="State *"
                      style={{ width: '48%' }}
                      value={state}
                      onChange={(_, value) => {
                        this.setFields('state', value);
                      }}
                      errorText={stateErrorMessage}
                    />

                    <TextField
                      floatingLabelText="City *"
                      style={{ width: '48%' }}
                      value={city}
                      onChange={(_, value) => {
                        this.setFields('city', value);
                      }}
                      errorText={cityErrorMessage}
                    />
                  </TextFieldContainer>

                  <TextField
                    floatingLabelText="Pincode *"
                    style={{ width: '48%' }}
                    value={pincode}
                    onChange={(_, value) => {
                      this.setFields('pincode', value);
                    }}
                    errorText={pincodeErrorMessage}
                  />

                  <TextField
                    floatingLabelText="Institute Website *"
                    fullWidth
                    value={website}
                    onChange={(_, value) => {
                      this.setFields('website', value);
                    }}
                    errorText={websiteErrorMessage}
                  />

                  <TextField
                    floatingLabelText="Affiliated University *"
                    fullWidth
                    value={university}
                    onChange={(_, value) => {
                      this.setFields('university', value);
                    }}
                    errorText={universityErrorMessage}
                  />

                  <SelectField
                    floatingLabelText="Institute Type *"
                    fullWidth
                    value={instituteType}
                    onChange={(_, index, value) => {
                      this.setFields('instituteType', value);
                    }}
                    errorText={instituteTypeErrorMessage}
                  >
                    <MenuItem value="Government" primaryText="Government" />
                    <MenuItem value="Deemed(Govt)" primaryText="Deemed(Govt)" />
                    <MenuItem
                      value="Deemed(Private)"
                      primaryText="Deemed(Private)"
                    />
                    <MenuItem
                      value="Central University"
                      primaryText="Central University"
                    />
                    <MenuItem
                      value="Government Aided"
                      primaryText="Government Aided"
                    />
                    <MenuItem
                      value="Private Aided"
                      primaryText="Private Aided"
                    />
                    <MenuItem
                      value="Unaided Private"
                      primaryText="Unaided Private"
                    />
                    <MenuItem
                      value="University managed by Government"
                      primaryText="University managed by Government"
                    />
                    <MenuItem
                      value="University managed by Private"
                      primaryText="University managed by Private"
                    />
                  </SelectField>

                  <TextField
                    floatingLabelText="Year of Establishment *"
                    fullWidth
                    value={collegeYear}
                    onChange={(_, value) => {
                      this.setFields('collegeYear', value);
                    }}
                    errorText={collegeYearErrorMessage}
                  />

                  <CardHeader
                    title="Degrees"
                    subtitle={degreesErrorMessage}
                    subtitleColor={theme.primary1Color}
                    style={{ paddingLeft: 0 }}
                  />
                  <CheckboxWrapper>
                    <CheckboxContainer>
                      <Checkbox
                        label="B.Tech / B.E."
                        onCheck={(_, isChecked) => {
                          if (isChecked) {
                            this.addDegree('B.Tech / B.E.');
                          } else {
                            this.removeDegree('B.Tech / B.E.');
                          }
                        }}
                        checked={this.isDegreePresent('B.Tech / B.E.')}
                      />
                      <Checkbox
                        label="BBA"
                        onCheck={(_, isChecked) => {
                          if (isChecked) {
                            this.addDegree('BBA');
                          } else {
                            this.removeDegree('BBA');
                          }
                        }}
                        checked={this.isDegreePresent('BBA')}
                      />
                      <Checkbox
                        label="BCA"
                        onCheck={(_, isChecked) => {
                          if (isChecked) {
                            this.addDegree('BCA');
                          } else {
                            this.removeDegree('BCA');
                          }
                        }}
                        checked={this.isDegreePresent('BCA')}
                      />
                      <Checkbox
                        label="B.Sc"
                        onCheck={(_, isChecked) => {
                          if (isChecked) {
                            this.addDegree('B.Sc');
                          } else {
                            this.removeDegree('B.Sc');
                          }
                        }}
                        checked={this.isDegreePresent('B.Sc')}
                      />

                      <Checkbox
                        label="U.G. Diploma"
                        onCheck={(_, isChecked) => {
                          if (isChecked) {
                            this.addDegree('U.G. Diploma');
                          } else {
                            this.removeDegree('U.G. Diploma');
                          }
                        }}
                        checked={this.isDegreePresent('U.G. Diploma')}
                      />
                    </CheckboxContainer>
                    <CheckboxContainer>
                      <Checkbox
                        label="M.Tech / M.E."
                        onCheck={(_, isChecked) => {
                          if (isChecked) {
                            this.addDegree('M.Tech / M.E.');
                          } else {
                            this.removeDegree('M.Tech / M.E.');
                          }
                        }}
                        checked={this.isDegreePresent('M.Tech / M.E.')}
                      />

                      <Checkbox
                        label="MBA"
                        onCheck={(_, isChecked) => {
                          if (isChecked) {
                            this.addDegree('MBA');
                          } else {
                            this.removeDegree('MBA');
                          }
                        }}
                        checked={this.isDegreePresent('MBA')}
                      />

                      <Checkbox
                        label="MCA"
                        onCheck={(_, isChecked) => {
                          if (isChecked) {
                            this.addDegree('MCA');
                          } else {
                            this.removeDegree('MCA');
                          }
                        }}
                        checked={this.isDegreePresent('MCA')}
                      />

                      <Checkbox
                        label="MSc"
                        onCheck={(_, isChecked) => {
                          if (isChecked) {
                            this.addDegree('MSc');
                          } else {
                            this.removeDegree('MSc');
                          }
                        }}
                        checked={this.isDegreePresent('MSc')}
                      />

                      <Checkbox
                        label="P.G. Diploma"
                        onCheck={(_, isChecked) => {
                          if (isChecked) {
                            this.addDegree('P.G. Diploma');
                          } else {
                            this.removeDegree('P.G. Diploma');
                          }
                        }}
                        checked={this.isDegreePresent('P.G. Diploma')}
                      />
                    </CheckboxContainer>
                  </CheckboxWrapper>
                  <TextField
                    fullWidth
                    floatingLabelText="Type any other missing degree"
                    value={degreeText}
                    onChange={(_, value) => {
                      this.setState(() => ({
                        degreeText: value,
                      }));
                    }}
                    onKeyDown={(event) => {
                      if (event.keyCode === 13) {
                        this.addDegree(degreeText);
                        this.setState(() => ({
                          degreeText: '',
                        }));
                      }
                    }}
                  />
                  <ChipsContainer>
                    {degrees.map(degree => (
                      <Chip
                        key={degree}
                        style={{
                          marginRight: 8,
                          marginBottom: 8,
                        }}
                        onRequestDelete={() => {
                          this.removeDegree(degree);
                        }}
                      >
                        {degree}
                      </Chip>
                    ))}
                  </ChipsContainer>
                  <AutoComplete
                    hintText="Type stream and press enter to select"
                    dataSource={this.getAvailStreams()}
                    filter={(searchText, key) =>
                      includes(lowerCase(key), lowerCase(searchText))
                    }
                    searchText={streamSearchText}
                    onUpdateInput={(searchText) => {
                      this.changeStateValue('streamSearchText', searchText);
                    }}
                    floatingLabelText="Stream Eligible *"
                    onNewRequest={(streamSelected) => {
                      this.addStream(streamSelected);
                    }}
                    errorText={streamsErrorMessage}
                    fullWidth
                  />
                  <ChipsContainer>
                    {streams.map(stream => (
                      <Chip
                        key={stream.id}
                        onRequestDelete={() => {
                          this.removeStream(stream.id);
                        }}
                        style={{
                          marginRight: 8,
                          marginBottom: 8,
                        }}
                      >
                        {stream.stream}
                      </Chip>
                    ))}
                  </ChipsContainer>
                  <TextField
                    floatingLabelText="Current Strength *"
                    fullWidth
                    value={currentStrength}
                    onChange={(_, value) => {
                      this.setFields('currentStrength', value);
                    }}
                    errorText={currentStrengthErrorMessage}
                  />

                  <CardTitle
                    title="Contact Information"
                    style={{ paddingLeft: 0 }}
                  />
                  <CardHeader
                    title="Chairman Contact *"
                    subtitle={promoterContactErrorMessage}
                    subtitleColor={theme.primary1Color}
                    style={{ paddingLeft: 0 }}
                  />
                  <ContentContainer>
                    {promoterContact.map(contact => (
                      <Card style={{ position: 'relative' }} key={contact.id}>
                        <CardHeader
                          title={contact.name}
                          subtitle={`${contact.email} | ${contact.primaryNum}`}
                        />
                        <CardIcon>
                          <IconButton>
                            <CloseIcon
                              color={theme.primary1Color}
                              onTouchTap={() => {
                                this.removePromoterContact(contact.id);
                              }}
                            />
                          </IconButton>
                        </CardIcon>
                      </Card>
                    ))}
                  </ContentContainer>
                  {promoterShow ? (
                    <div>
                      <TextFieldContainer>
                        <TextField
                          floatingLabelText="Name of Contact"
                          hintText="Name of Contact"
                          style={{ width: '48%' }}
                          value={promoterName}
                          onChange={(_, value) => {
                            this.setFields('promoterName', value);
                          }}
                          errorText={promoterNameErrorMessage}
                        />

                        <TextField
                          floatingLabelText="Email Address"
                          hintText="Enter valid emial id"
                          style={{ width: '48%' }}
                          value={promoterEmail}
                          onChange={(_, value) => {
                            this.setFields('promoterEmail', value);
                          }}
                          errorText={promoterEmailErrorMessage}
                        />
                      </TextFieldContainer>

                      <TextFieldContainer>
                        <TextField
                          floatingLabelText="Primary Contact Number"
                          hintText="Enter 10 digit phone number"
                          style={{ width: '48%' }}
                          value={promoterPrimaryNum}
                          onChange={(_, value) => {
                            this.setFields('promoterPrimaryNum', value);
                          }}
                          errorText={promoterPrimaryNumErrorMessage}
                        />

                        <TextField
                          floatingLabelText="Secondary Contact Number"
                          hintText="Enter 10 digit phone number"
                          style={{ width: '48%' }}
                          value={promoterSecondaryNum}
                          onChange={(_, value) => {
                            this.setFields('promoterSecondaryNum', value);
                          }}
                        />
                      </TextFieldContainer>
                      <CardActions style={{ marginTop: '8px' }}>
                        <RaisedButton
                          label="Save"
                          primary
                          onTouchTap={this.addPromoterContact}
                        />
                        <FlatButton
                          label="Cancel"
                          primary
                          onTouchTap={this.cancelPromoter}
                        />
                      </CardActions>
                    </div>
                  ) : (
                    <CardActions>
                      <RaisedButton
                        label="Add Contact"
                        primary
                        onTouchTap={this.showPromoterFields}
                      />
                    </CardActions>
                  )}
                  <CardHeader
                    title="Director/Principal *"
                    style={{ paddingLeft: 0 }}
                  />

                  <TextFieldContainer>
                    <TextField
                      floatingLabelText="Name"
                      hintText="Name of Contact"
                      style={{ width: '48%' }}
                      value={principleName}
                      onChange={(_, value) => {
                        this.setFields('principleName', value);
                      }}
                      errorText={principleNameErrorMessage}
                    />

                    <TextField
                      floatingLabelText="Email Address"
                      hintText="Enter email address"
                      style={{ width: '48%' }}
                      value={principleEmail}
                      onChange={(_, value) => {
                        this.setFields('principleEmail', value);
                      }}
                      errorText={principleEmailErrorMessage}
                    />
                  </TextFieldContainer>
                  <TextFieldContainer>
                    <TextField
                      floatingLabelText="Primary Contact Number"
                      hintText="Enter 10 digit phone number"
                      style={{ width: '48%' }}
                      value={principlePrimaryNum}
                      onChange={(_, value) => {
                        this.setFields('principlePrimaryNum', value);
                      }}
                      errorText={principlePrimaryNumErrorMessage}
                    />

                    <TextField
                      floatingLabelText="Secondary Contact Number"
                      hintText="Enter 10 digit phone number"
                      style={{ width: '48%' }}
                      value={principleSecondaryNum}
                      onChange={(_, value) => {
                        this.setFields('principleSecondaryNum', value);
                      }}
                    />
                  </TextFieldContainer>

                  <CardHeader
                    title="Head of Training and Placement *"
                    style={{ paddingLeft: 0 }}
                  />

                  <TextFieldContainer>
                    <TextField
                      floatingLabelText="Name"
                      hintText="Name of Contact"
                      style={{ width: '48%' }}
                      value={headTpoName}
                      onChange={(_, value) => {
                        this.setFields('headTpoName', value);
                      }}
                      errorText={headTpoNameErrorMessage}
                    />

                    <TextField
                      floatingLabelText="Email Address"
                      hintText="Enter email address"
                      style={{ width: '48%' }}
                      value={headTpoEmail}
                      onChange={(_, value) => {
                        this.setFields('headTpoEmail', value);
                      }}
                      errorText={headTpoEmailErrorMessage}
                    />
                  </TextFieldContainer>
                  <TextFieldContainer>
                    <TextField
                      floatingLabelText="Primary Contact Number"
                      hintText="Enter 10 digit phone number"
                      style={{ width: '48%' }}
                      value={headTpoPrimaryNum}
                      onChange={(_, value) => {
                        this.setFields('headTpoPrimaryNum', value);
                      }}
                      errorText={headTpoPrimaryNumErrorMessage}
                    />

                    <TextField
                      floatingLabelText="Secondary Contact Number"
                      hintText="Enter 10 digit phone number"
                      style={{ width: '48%' }}
                      value={headTpoSecondaryNum}
                      onChange={(_, value) => {
                        this.setFields('headTpoSecondaryNum', value);
                      }}
                    />
                  </TextFieldContainer>

                  <CardTitle
                    title="Accreditations *"
                    subtitle={accreditationsErrorMessage}
                    subtitleColor={theme.accent1Color}
                    style={{ paddingLeft: 0 }}
                  />
                  <ContentContainer>
                    {accreditations.map(accred => (
                      <Card style={{ position: 'relative' }} key={accred.id}>
                        <CardHeader
                          title={accred.name}
                          subtitle={accred.year}
                        />
                        <CardIcon>
                          <IconButton>
                            <CloseIcon
                              color={theme.primary1Color}
                              onTouchTap={() => {
                                this.removeAccred(accred.id);
                              }}
                            />
                          </IconButton>
                        </CardIcon>
                      </Card>
                    ))}
                  </ContentContainer>
                  {accredShow ? (
                    <div>
                      <TextFieldContainer>
                        <TextField
                          floatingLabelText="Accreditation Name"
                          hintText="NACC, NBA, any other"
                          style={{ width: '48%' }}
                          value={accredName}
                          onChange={(_, value) => {
                            this.setFields('accredName', value);
                          }}
                          errorText={accredNameErrorMessage}
                        />

                        <SelectField
                          floatingLabelText="Accreditation Year"
                          hintText="Enter numbers"
                          style={{ width: '48%' }}
                          value={accredYear}
                          onChange={(_, index, value) => {
                            this.setFields('accredYear', value);
                          }}
                          errorText={accredYearErrorMessage}
                        >
                          {range(currentYear - 50, currentYear).map(yearVar => (
                            <MenuItem
                              key={yearVar}
                              value={yearVar}
                              primaryText={yearVar}
                            />
                          ))}
                        </SelectField>
                      </TextFieldContainer>
                      <TextField
                        floatingLabelText="Description"
                        hintText="brief description, streams accreditied, ranking etc."
                        multiLine
                        fullWidth
                        value={accredDesc}
                        onChange={(_, value) => {
                          this.setFields('accredDesc', value);
                        }}
                        errorText={accredDescErrorMessage}
                      />
                      <CardActions>
                        <RaisedButton
                          label="Save"
                          primary
                          onTouchTap={this.addAccred}
                        />
                        <FlatButton
                          label="Cancel"
                          primary
                          onTouchTap={this.cancelAccred}
                        />
                      </CardActions>
                    </div>
                  ) : (
                    <CardActions>
                      <RaisedButton
                        label="Add More"
                        primary
                        onTouchTap={this.showAccredFields}
                      />
                    </CardActions>
                  )}
                </CardText>
              </Card>
              <CardActions>
                <RaisedButton
                  label="Update"
                  primary
                  onTouchTap={() => {
                    if (!this.validateInfo()) {
                      this.openConfirmModal();
                    }
                  }}
                />
                <FlatButton
                  label="Cancel"
                  onTouchTap={() => {
                    history.push('/campuscape/campus');
                  }}
                />
              </CardActions>
            </ContentWrapper>
            <Dialog
              title="Create Institute"
              modal
              actions={[
                <FlatButton
                  label="Cancel"
                  primary
                  onTouchTap={this.closeConfirmModal}
                />,
                <RaisedButton
                  label="Submit"
                  primary
                  onTouchTap={() => {
                    this.updateCollege();
                    // this.resetFields();
                  }}
                />,
              ]}
              open={confirmModalOpen}
              onRequestClose={this.closeConfirmModal}
            >
              <CardText>
                Please confirm the data that you have filled. Are you sure?
              </CardText>
            </Dialog>
          </div>
        )}
      </div>
    );
  }
}

EarlyBirdCollegeEdit.propTypes = {
  match: PropTypes.object.isRequired, // eslint-disable-line
  history: PropTypes.object.isRequired, // eslint-disable-line
};

export default EarlyBirdCollegeEdit;



// WEBPACK FOOTER //
// ./src/views/EarlyBirdCollege/EarlyBirdCollegeEdit.js